import { useMemo, useState } from "react";
import { GetTitleActiveRightData, GetTitleContentData } from "../../../../../Redux/Reducers/redux-slice-asset";
import { useAppSelector } from "../../../../../Redux/redux-store";
import TitleContent from "../../../../Title/title-content";
import { DbAssetObjectInfos } from "../../../../../Core/Api/Types/db-asset-object-infos";
import { Container } from "@mui/material";

function AdminTitleContentsAndMetadata() {
  const titleContentData = useAppSelector(GetTitleContentData);
  const titleActiveRightData = useAppSelector(GetTitleActiveRightData);
  const [selectedContents, setSelectedContents] = useState<DbAssetObjectInfos[]>([]);

  // Really important, avoid to re-render all the TitleContent component while playing web player!
  const memoData = useMemo(() => titleContentData, [titleContentData?.id]);

  return (
    <TitleContent
      titleContentData={memoData}
      titleActiveRightData={titleActiveRightData}
      selectedContents={selectedContents}
      setSelectedContents={setSelectedContents}
    />
  );
}

export default AdminTitleContentsAndMetadata;
